

var _route = require('../../confirm-upop/route');

var _route2 = _interopRequireDefault(_route);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

define(['squid/index', './directive'], function (squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xo-add-card.addcard.route', ['squid', 'xo-add-card.addcard.directive']).factory('$AddCardRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('AddCardRoute', {

            name: 'addCard',
            directive: 'xo-add-card',
            titleContent: 'asideHeader.addCard',

            trackingData: {
                fptiState: 'add_or_update_cc'
            },
            loginRequired: true,
            children: [{
                route: _route2['default'],
                attributes: {
                    token: 'token',
                    phone: 'phone',
                    cardmodel: 'cardmodel'
                }
            }]
        });
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-wallet-components/src/add-card/addcard/route.js
 ** module id = 268
 ** module chunks = 1
 **/